/** null/undefined stock = unlimited (admin has not set a quantity yet). */
export function remainingStock(product) {
  if (product?.stock == null || product.stock === '') return null;
  const n = Number(product.stock);
  return Number.isFinite(n) ? Math.max(0, Math.floor(n)) : null;
}

export function isOutOfStock(product) {
  const left = remainingStock(product);
  return left === 0;
}

export function maxPurchaseQty(product, fallback = 20) {
  const left = remainingStock(product);
  if (left == null) return fallback;
  return Math.max(0, Math.min(fallback, left));
}
